import React from "react";
import { Button, Row, Col, Typography, Card, Collapse } from "antd";
// import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import {
//   showErrorToast,
//   showSuccessToast,
// } from "../../../NotificationToast/NotificationToast";
import { ArrowLeftOutlined } from "@ant-design/icons";

import MobBannerIcon from "../../../assets/seller/icons/MobActivation_Banner.webp";
import MoneyHandLogo from "../../../assets/seller/icons/money-hand.webp";
import { ReactComponent as LampLogo } from "../../../assets/seller/icons/lamp.svg";
import { ReactComponent as IndiaFlagLogo } from "../../../assets/seller/icons/india_flag.svg";
import RupifyLogo from "../../../assets/seller/icons/rupify_nobg.webp";
import MuthoothLogo from "../../../assets/seller/icons/muthooth.svg";
import MobCreditBlackIcon from "../../../assets/seller/icons/mobcredit-black.svg";
import liquilogo from "../../../assets/seller/icons/liquilogo.webp";
import { ReactComponent as MobCreditIcon } from "../../../assets/seller/icons/Mobcreditlogo.svg";

import Whattoexpect from "./whattoexpect";

import Rejectclients from "./rejectclients";
import AboutMobCredit from "./AboutMobCredit";
import CommercialsTerms from "./CommercialsTerms";
import Howtouse from "./howtouse";

const CustomerMobHowtouse = () => {
  const Text = Typography;

  // const nameRegex = /^[a-zA-Z\s]{3,}$/;
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: "What expectations to set for your customer (with GSTIN)",
      children: <Whattoexpect />,
    },
    {
      key: "2",
      label: "About mobCREDIT",
      children: <AboutMobCredit />,
    },
    {
      key: "3",
      label: "Commercials & terms",
      children: <CommercialsTerms />,
    },
    {
      key: "4",
      label: "How to use mobCREDIT",
      children: <Howtouse />,
    },
    {
      key: "5",
      label: "How to handle REJECTED clients",
      children: <Rejectclients />,
    },
  ];

  const handleBack = () => {
    navigate("/seller/sellerdashboard");
  };
  return (
    <>
      <Row>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 24, offset: 0 }}
          lg={{ span: 24, offset: 0 }}
          xl={{ span: 24, offset: 0 }}
        >
          <Col>
            <Text>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleBack}
                className="view-detail-btn"
              >
                BACK TO DASHBOARD
              </Button>
            </Text>
          </Col>

          <Row>
            <Col>
              <Row gutter={16} type="flex">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="text-center"
                >
                  <img src={MobBannerIcon} className="banner-top" alt="" />
                </Col>
              </Row>
              <Row gutter={[16,16]} type="flex" className="mt-4">
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Card className="card-credit-section">
                    <MobCreditIcon  className="credit-icon" />
                    <Col>
                      <Typography.Title level={3}>
                        1st time in India <IndiaFlagLogo    className="india-flag-icon" />
                      </Typography.Title>
                      <Text className="made-india">MADE IN INDIA</Text>
                    </Col>

                    <Col className="mt-4 mb-2">Backed by:</Col>
                    <Col
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "12px",
                         flexWrap:"wrap"
                      }}
                    >
                      <img alt="" src={MuthoothLogo}></img>
                      <img
                        alt=""
                        src={liquilogo}
                        style={{ height: "100%" }}
                      ></img>
                      <img alt="" src={MobCreditBlackIcon}></img>
                      <img alt="" src={RupifyLogo}></img>
                    </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Card className="card-tips-section">
                    <Col span={24} className="p-0">
                      {" "}
                      <Text className="text-heading-sm">
                        <LampLogo /> Did you know?
                      </Text>
                    </Col>
                    <Col span={24} className="p-0">
                      <Text className="text-heading-sm-details">
                        4 Lakh crores or USD 50 billion dollars is given out in
                        line of credit to architects, contractors & builders in
                        this sector of construction and interior materials by
                        the suppliers like you on their own books
                      </Text>
                      <Col>
                        {" "}
                        <img
                          alt=""
                          className="money-hand"
                          src={MoneyHandLogo}
                        ></img>
                      </Col>
                    </Col>
                  </Card>
                </Col>
              </Row>
              <Text className="text-subtext">
                In accordance with RBI regulations
              </Text>
            </Col>
          </Row>
          <Row className="mt-6">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Collapse
                className="collapse-section"
                accordion
                expandIconPosition="end"
                defaultActiveKey={1}
              >
                {items.map((item) => (
                  <Collapse.Panel key={item.key} header={item.label}>
                    {item.children}
                  </Collapse.Panel>
                ))}
              </Collapse>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default CustomerMobHowtouse;
